<script>  
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import StrIyilestirmeBirim from "@/models/StrIyilestirmeBirim";
import Swal from "sweetalert2";
import moment from 'moment' 
export default {
  mixins: [Api, Sabit,StrIyilestirmeBirim],
  props: ["Id","BirimSayisi","TamamlananSayisi"],
  data() {
    return {
      TableData: null,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      HatirlarmaMail: null,
      HatirlarmaMesaj: null,
      Tarih: moment(new Date()).format('YYYY-MM-DD'),
      FILES_URL: null
    };
  },
  components: {
    Loader,  
  
  },
  watch: {
    Id() {
      if(this.Id){
        this.FilterGet()
      }
    },
  },
  methods: { 
    Get() {},
    FilterGet(){

      this.ActionsFilterGet({ Service: "StrIyilestirmeBirim", Page: this.Page, Filter: "&Iyilestirmeid=" + this.Id }).then((res) => {

        var Data = res.Data;
        for (let index = 0; index < Data.length; index++) {
          const element = Data[index];
           element.Revizyonaciklama =  this.TryParseJson(element.Revizyonaciklama)
           element.Kanit =  this.TryParseJson(element.Kanit)
        }
          this.TableData = Data;
          this.Page.PageDataSize = res.TotalCount;
        });
    },
    RevizyonGonder(Data){ 

 
      Swal.fire({
        title: "İyileştirmeyi Revizyona Gönder ",
        text: "Seçtiğiniz iyileştirme planı revizyon için gönderilecektir",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Durum = 3
          Data.Revizyonaciklama = JSON.stringify(Data.Revizyonaciklama)
          Data.Kanit = JSON.stringify(Data.Kanit)
          this.Update("StrIyilestirmeBirim", Data, "İyileştirme Planı Revizyona Gönderildi").then((res) => {
            if (res) {
                Data.Revizyonaciklama = JSON.parse(Data.Revizyonaciklama)
                Data.Kanit = JSON.parse(Data.Kanit)
            }
          })
        }
      });
    },
    HatirlatmaMailiGonder(){

      if(this.HatirlarmaMail && this.HatirlarmaMesaj){
            this.Post("StrIyilestirmeBirim/MailGonderim", 
              {
                To: this.HatirlarmaMail,
                Body: this.HatirlarmaMesaj
              }, "Mail Gönderildi"
            ) 
      }
      else{
         this.$toast.error("Alanları Doldurun");
      }

    },
    
    Onayla(Data){ 
      Swal.fire({
        title: "İyileştirmeyi Planını Onayla ",
        text: "Seçtiğiniz iyileştirme planı onaylanacaktır",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Durum = 4
          Data.Revizyonaciklama = JSON.stringify(Data.Revizyonaciklama)
          Data.Kanit = JSON.stringify(Data.Kanit)
          this.Update("StrIyilestirmeBirim", Data, "İyileştirme Planı Onaylandı").then((res) => {
            if (res) {
                Data.Revizyonaciklama = JSON.parse(Data.Revizyonaciklama)
                Data.Kanit = JSON.parse(Data.Kanit)
            }
          })
        }
      });
    },

    TryParseJson(param) {
    try { 
      if (typeof param === "string") {
        return JSON.parse(param);
      } 
      if (typeof param === "object" && param !== null) {
        return param;
      } 
      return [];
    } catch (e) { 
      return [];
    }
  },
  
  isLink(text) {
    const urlPattern = /^(https?:\/\/|www\.)[^\s]+$/i;
    return urlPattern.test(text);
  }


  },
  created() {

    this.FILES_URL = this.$config.FILES_URL;
  }
};
</script>
<style>
.custom-modal-width {
  max-width: 95% !important;
}
</style>
<template>
  <Loader>


 <b-modal
      id="HatirlatmaMail"
      size="m"
      title="Hatırlatma Maili"
      title-class="font-18"
      hide-footer
    > 
  <b>Hatırlatma Maili Gönderilecekler: </b> {{ HatirlarmaMail   }}<br> <br> 

    

     <b class="mt-3">Hatırlarma Mesajı: </b> <textarea      class="form-control mt-3" 
        v-model="HatirlarmaMesaj"  
      ></textarea>
 

        <button class="btn btn-primary mt-3" type="button" @click="HatirlatmaMailiGonder()">
         Gönder
        </button>
    </b-modal>



    <b-modal  
      id="BirimIyılestirmeleri"
      size="xl"
      title="İyileştirme Birimleri"
      title-class="font-18"
      hide-footer
  dialog-class="custom-modal-width"
    > Birim Saysisi / Tamamlanan Birim: {{ BirimSayisi }} / {{ TamamlananSayisi }}
    <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Birim</th> 
                      <th>Dönem</th> 
                      <th>Planlanan İyileştirme</th>
                      <th  v-if="0">İyileştirme</th>
                      <th>Gerçekleşme Durum</th> 
                      <th>Bitiş Ay</th>
                      <th>Bitiş Yıl</th>
                      <th>Kanıt</th>
                      <th>Revizyon Açıklaması</th>  
                      <th>Açıklama</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Birim}}</th>
                      <td>{{ Data.Donem }}</td>
                      <td  v-if="0">{{ Data.Iyilestirme }}</td>
                      <td>{{ Data.Planlananiyilestirme }}</td>
                      <td>{{ DurumEnum[Data.Durum] }}</td>
                      <td>{{ Data.Bitisay }}</td>
                      <td>{{ Data.Bitisyil }}</td>
                      <td> 

                        <div class="row" v-for="(value, index) in Data.Kanit" :key="index"> 
                       <b>   {{ value.Tarih }}; </b>
                          <span  v-if="value.Tip == 'Text'" >
<a  v-if="isLink(value.Kanit)" :href="value.Kanit"  target="_blank" class="text-primary text-decoration-underline">
        {{ value.Kanit }} </a> 
<span v-else>{{ value.Kanit }}</span> 
                          </span>
                          <a v-if="value.Tip == 'File'" :href="FILES_URL + 'str/' + value.Kanit" target="_blanl">
                            <i class="fas fa-eye" v-tooltip="'Dosya Görüntüle'"></i> {{ value.Kanit }}</a>
                        </div>
                      </td>

                      <td> 
                        <div class="row"  v-for="(value,index) in Data.Revizyonaciklama" :key="index"> 
                          <div class="col-md-4"> {{ Data.Revizyonaciklama[index].Tarih  }}</div>
                            <div class="col-md-8">
                            <textarea v-if="Data.Durum == 2" v-model="Data.Revizyonaciklama[index].Aciklama" :disabled=" Data.Durum == 4 ? true : false" class="form-control" ></textarea>
                          <span v-else>{{ Data.Revizyonaciklama[index].Aciklama }}</span>  
                          </div>
                        </div>
                      
                      </td> 
                      <td>{{ Data.Aciklama }}</td>
                      
                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          
                          <i  v-b-tooltip.hover title="Revizyon Ekle"   v-if="Data.Durum == 2" class="fas fa-plus" @click="Data.Revizyonaciklama.push({
                            'Aciklama': null, 'Tarih':  Tarih
                          });"></i> 
 
                          <i v-b-tooltip.hover title="Revizyona Gönder"  class="fas fa-undo" @click="RevizyonGonder(Data)" v-if="Data.Durum == 2"></i> 
                          <i v-b-tooltip.hover title="Onay"  class="fas fa-check" @click="Onayla(Data)" v-if="Data.Durum == 2"></i> 
                           
                          <i v-b-tooltip.hover title="Hatırlatma Maili"  class="fas fa-paper-plane" @click="HatirlarmaMail = Data.Birimmail"  v-b-modal.HatirlatmaMail   ></i>


                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
 

    </b-modal>
  </Loader>
</template>
